import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private http: HttpClient) {}

  download(attachment: { bytes: string; fileName: string }) {
    this.http
      .get(attachment.bytes, { responseType: 'blob' })
      .subscribe((blob) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = attachment.fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }
}
